import { defineStore } from 'pinia'

export const usePop = defineStore('use-pop', () => {
  const x = ref<number>(0)
  const y = ref<number>(0)
  const showPop = ref<boolean>(false)
  const reportTitle = ref<string | boolean>('')

  return { x, y, showPop, reportTitle }
})
